import { render, staticRenderFns } from "./WsExpertsManagement.vue?vue&type=template&id=415bc7ff&scoped=true"
import script from "./WsExpertsManagement.vue?vue&type=script&lang=js"
export * from "./WsExpertsManagement.vue?vue&type=script&lang=js"
import style0 from "./WsExpertsManagement.vue?vue&type=style&index=0&id=415bc7ff&prod&lang=css"
import style1 from "./WsExpertsManagement.vue?vue&type=style&index=1&id=415bc7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415bc7ff",
  null
  
)

export default component.exports